import { Component, OnInit,Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-modal-modificar-imagen',
  templateUrl: './modal-modificar-imagen.component.html',
  styleUrls: ['./modal-modificar-imagen.component.css']
})
export class ModalModificarImagenComponent implements OnInit {
  @Input() imageChangedEvent
  croppedImage : any
  cropperReady = false;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    
  }

  imageCropped(image: string):void {
    this.croppedImage = image;
  }
  imageLoaded():void {
    this.cropperReady = true;
  }

  imageLoadFailed (item) :void {
    console.log('Load failed', item);
  }

  enviarImagen() :void{
    this.activeModal.close(this.croppedImage);
  }



}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-modificar-imagen/modal-modificar-imagen.component.ts